import { Alert, AlertProps } from '@mui/material';
import { Box } from '@mui/system';
interface IFormMessage extends AlertProps {
  data: string;
}

export const FormMessage = ({ data, severity }: IFormMessage) => {
  return (
    <Box pt={1}>
      <Alert variant="outlined" severity={severity}>
        {severity === 'error' && Object.values(data).map((err) => err)}
        {severity === 'success' && data}
      </Alert>
    </Box>
  );
};
